import React from 'react';

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="space-y-2">
    <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
    <div className="text-gray-600 leading-relaxed">{children}</div>
  </div>
);

const ShippingPolicyPage: React.FC = () => (
  <div className="min-h-screen bg-[#FCFCFC] py-12 px-4 md:px-20">
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-800 mb-2">Shipping Policy</h1>
      <p className="text-gray-400 text-sm mb-8">Last updated: August 2026</p>
      <div className="bg-white rounded-xl shadow p-8 space-y-6">
        <Section title="1. Shipping Coverage">
          <p>We ship across India. Currently we do not offer international shipping.</p>
        </Section>
        <Section title="2. Processing Time">
          <p>Orders are processed within 1–2 business days after placement. Orders placed on weekends or public holidays are processed the next business day.</p>
        </Section>
        <Section title="3. Delivery Time">
          <p>Standard delivery takes 5–7 business days depending on your location. Remote areas may take up to 10 business days.</p>
        </Section>
        <Section title="4. Shipping Charges">
          <p>We offer free shipping on all orders. No minimum order value required.</p>
        </Section>
        <Section title="5. Order Tracking">
          <p>Once your order is shipped, you can track it from the "My Orders" section in your account.</p>
        </Section>
        <Section title="6. Delivery Issues">
          <p>If your order is delayed beyond the expected delivery window or is lost in transit, please contact us at <span className="text-[#DAA520]">sastadealpvt@gmail.com</span> with your order number.</p>
        </Section>
      </div>
    </div>
  </div>
);

export default ShippingPolicyPage;
